<div class="pointer-events-none h-100">
  @if (navBarDesktopConfig.useHtml) {
  <nav
    #contentContainer
    class="navbar d-flex align-items-center"
    [ngStyle]="footerStyles"
    [ngClass]="{
      'vertical-layout': navBarDesktopConfig.menuType === 'vertical',
      'horizontal-layout': navBarDesktopConfig.menuType === 'horizontal'
    }"
  >
    <finxone-web-frontend-custom-navbar
      [htmlContent]="navBarDesktopConfig.htmlContent"
    ></finxone-web-frontend-custom-navbar>
  </nav>
  } @else {
  <nav
    class="navbar d-flex align-items-center"
    [ngStyle]="footerStyles"
    [ngClass]="{
      'vertical-layout': navBarDesktopConfig.menuType === 'vertical',
      'horizontal-layout': navBarDesktopConfig.menuType === 'horizontal'
    }"
    [attr.id]="
      navBarDesktopConfig.menuType === 'vertical' ? 'desktop-vertical-navbar' : 'desktop-horizontal-navbar'
    "
  >
    <div
      class="is-left"
      [ngClass]="{
        'logo-horizontal': navBarDesktopConfig.menuType === 'horizontal',
        'logo-vertical': navBarDesktopConfig.menuType === 'vertical',
      }"
    >
      <ng-container *ngIf="navBarDesktopConfig.logoType === 'text'">
        <div class="mx-2">
          <b class="logo-text"> {{ logoName }}</b>
        </div>
      </ng-container>
      <ng-container *ngIf="navBarDesktopConfig.logoType === 'icon'">
        <mat-icon class="side-logo" svgIcon="customer-logo"></mat-icon>
      </ng-container>
    </div>
    <ng-container *ngFor="let item of navBarDesktopConfig?.layout; let i = index">
      <div>
        <a
          class="navbar-item cursor-pointer"
          (click)="navigateToZone(item.navigateToZone)"
          [ngClass]="{
            'vertical-highlight': activeItems[i] && navBarDesktopConfig.menuType === 'vertical'
          }"
          [ngStyle]="{
            'background-color':
              activeItems[i] && navBarDesktopConfig.menuType === 'vertical'
                ? navBarDesktopConfig.activeItemColor
                : ''
          }"
        >
          <mat-icon
            [ngStyle]="iconStyles"
            [style.color]="activeItems[i] ? item.activeIconColor : item.inactiveIconColor"
            class="img-fluid ml-1 nonactive"
            [svgIcon]="item.icon"
            [ngClass]="activeItems[i] ? 'active' : 'nonactive'"
          ></mat-icon>
          <span
            class="ml-1"
            [style.color]="activeItems[i] ? item.activeIconColor : item.inactiveIconColor"
            [ngClass]="activeItems[i] ? 'active' : 'nonactive'"
            >{{ item.title ? item.title : '&nbsp;' }}</span
          >
        </a>
      </div>
    </ng-container>
    <div class="horizontal-role" *ngIf="navBarDesktopConfig.menuType === 'horizontal' && this.userName">
      <span [style.color]="navBarDesktopConfig.userNameColor">
        {{ userName }}
      </span>
      <a (click)="onLogout()">
        <mat-icon
          [style.color]="navBarDesktopConfig.logOutColor"
          class="chevron-down"
          svgIcon="chevron-down"
          alt="chevron-down"
        ></mat-icon>
      </a>
    </div>
    <div class="role-container" *ngIf="navBarDesktopConfig.menuType === 'vertical' && this.userName">
      <span [style.color]="navBarDesktopConfig.userNameColor" class="user-name m1-1">
        {{ userName }}
      </span>
      <div>
        <a class="logout cursor-pointer" (click)="logout()">
          <mat-icon
            [style.color]="navBarDesktopConfig.logOutColor"
            class="logout-icon"
            svgIcon="sign-out"
            alt="sign-out"
          ></mat-icon>
          <span [style.color]="navBarDesktopConfig.logOutColor"> Logout Account</span>
        </a>
      </div>
    </div>
  </nav>
  }
</div>
